import { Fragment, useState, useEffect } from "react";
import { Dialog, Disclosure, Menu, Transition } from "@headlessui/react";
import { XMarkIcon, MinusIcon, PlusIcon, FunnelIcon, Squares2X2Icon } from "@heroicons/react/20/solid";
import ProductCard from "../ProductCard/newProductCard";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  findProducts,
} from "../../../../Redux/Customers/Product/Action";
import { filters, singleFilter, sortOptions } from "./FilterData";
import Pagination from "@mui/material/Pagination";
import FormControl from "@mui/material/FormControl";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import BackdropComponent from "../../BackDrop/Backdrop";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export default function Product() {
  const [mobileFiltersOpen, setMobileFiltersOpen] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const param = useParams();
  const location = useLocation();
  const { customersProduct } = useSelector((store) => store);

  const [allProducts, setAllProducts] = useState([]);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [activeTitleFilter, setActiveTitleFilter] = useState("all");
  const [isLoaderOpen, setIsLoaderOpen] = useState(false);

  const decodedQueryString = decodeURIComponent(location.search);
  const searchParams = new URLSearchParams(decodedQueryString);
  const colorValue = searchParams.get("color");
  const sizeValue = searchParams.get("size");
  const price = searchParams.get("price");
  const disccount = searchParams.get("disccout");
  const sortValue = searchParams.get("sort");
  const pageNumber = searchParams.get("page") || 1;
  const stock = searchParams.get("stock");

  const [minPrice, maxPrice] = price === null ? [0, 10000] : price.split("-").map(Number);

  useEffect(() => {
    const data = {
      category: param.lavelThree,
      colors: colorValue || [],
      sizes: sizeValue || [],
      minPrice: minPrice || 0,
      maxPrice: maxPrice || 10000,
      minDiscount: disccount || 0,
      sort: sortValue || "price_low",
      pageNumber: 1,
      pageSize: 100, // Fetch larger batch so we can filter locally
      stock: stock,
    };
    dispatch(findProducts(data));
  }, [param.lavelThree]);

  useEffect(() => {
    if (customersProduct.products?.content) {
      setAllProducts(customersProduct.products.content);
      setFilteredProducts(customersProduct.products.content);
    }
  }, [customersProduct.products]);

  useEffect(() => {
    if (customersProduct.loading) {
      setIsLoaderOpen(true);
    } else {
      setIsLoaderOpen(false);
    }
  }, [customersProduct.loading]);
  const searchParamss = new URLSearchParams(location.search);
const titleQuery = searchParamss.get("title");
useEffect(() => {
  if (titleQuery) {
    handleTitleFilter(titleQuery);
  }
}, [titleQuery, allProducts]);
  const handleTitleFilter = (keyword) => {
    setActiveTitleFilter(keyword);

    if (keyword === "all") {
      setFilteredProducts(allProducts);
    } else {
      const filtered = allProducts.filter((item) =>
        item.title.toLowerCase().includes(keyword.toLowerCase())
      );
      setFilteredProducts(filtered);
    }
  };
  
  const handleSortChange = (value) => {
    const searchParams = new URLSearchParams(location.search);
    searchParams.set("sort", value);
    const query = searchParams.toString();
    navigate({ search: `?${query}` });
  };

  const handlePaginationChange = (event, value) => {
    const searchParams = new URLSearchParams(location.search);
    searchParams.set("page", value);
    const query = searchParams.toString();
    navigate({ search: `?${query}` });
  };
 
  return (
    <div className="bg-white -z-20 ">
      <main className="mx-auto px-4 lg:px-14">
        <div className="flex items-baseline justify-between border-b border-gray-200 pb-6">
          <h1 className="text-4xl font-bold tracking-tight text-gray-900 mt-5">
            ALL PRODUCTS
          </h1>
          <div className="flex items-center">
            <Menu as="div" className="relative inline-block text-left">
              <div>
                <Menu.Button className="group inline-flex justify-center text-sm font-medium text-gray-700 hover:text-gray-900">
                  Sort
                </Menu.Button>
              </div>
              <Transition
                as={Fragment}
                enter="transition ease-out duration-100"
                enterFrom="transform opacity-0 scale-95"
                enterTo="transform opacity-100 scale-100"
                leave="transition ease-in duration-75"
                leaveFrom="transform opacity-100 scale-100"
                leaveTo="transform opacity-0 scale-95"
              >
                <Menu.Items className="absolute right-0 z-10 mt-2 w-40 origin-top-right rounded-md bg-white shadow-2xl ring-1 ring-black ring-opacity-5 focus:outline-none">
                  <div className="py-1">
                    {sortOptions.map((option) => (
                      <Menu.Item key={option.name}>
                        {({ active }) => (
                          <p
                            onClick={() => handleSortChange(option.query)}
                            className={classNames(
                              option.current ? "font-medium text-gray-900" : "text-gray-500",
                              active ? "bg-gray-100" : "",
                              "block px-4 py-2 text-sm cursor-pointer"
                            )}
                          >
                            {option.name}
                          </p>
                        )}
                      </Menu.Item>
                    ))}
                  </div>
                </Menu.Items>
              </Transition>
            </Menu>
            <button type="button" className="-m-2 ml-5 p-2 text-gray-400 hover:text-gray-500 sm:ml-7">
              <Squares2X2Icon className="h-5 w-5" aria-hidden="true" />
            </button>
            <button
              type="button"
              className="-m-2 ml-4 p-2 text-gray-400 hover:text-gray-500 sm:ml-6 lg:hidden"
              onClick={() => setMobileFiltersOpen(true)}
            >
              <FunnelIcon className="h-5 w-5" aria-hidden="true" />
            </button>
          </div>
        </div>

        {/* Title filters */}
        <div className="flex flex-wrap gap-3 py-5">
          {["all", "agarbatti", "cones", "cups", "gulab", "gift", "ashtagandh"].map((keyword) => (
            <button
              key={keyword}
              onClick={() => handleTitleFilter(keyword)}
              className={`px-4 py-2 rounded-full border ${
                activeTitleFilter === keyword ? "bg-black text-white" : "bg-white text-black border-gray-300"
              }`}
            >
              {keyword.toUpperCase()}
            </button>
          ))}
        </div>

        {/* Product grid */}
        <section aria-labelledby="products-heading" className="pb-24 pt-6">
          <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-5 bg-white border py-5 rounded-md">
            {filteredProducts.map((item, idx) => (
              <ProductCard key={idx} product={item} />
            ))}
          </div>
        </section>

        {/* Pagination */}
        <section className="w-full px-[3.6rem]">
          <div className="mx-auto px-4 py-5 flex justify-center shadow-lg border rounded-md">
            <Pagination
              count={customersProduct.products?.totalPages}
              color="primary"
              onChange={handlePaginationChange}
            />
          </div>
        </section>

        <BackdropComponent open={isLoaderOpen} />
      </main>
    </div>
  );
}
